
/**
 * Prevents cover section resize on mobile devices when you scroll down
 */

import { TweenLite } from 'gsap/TweenLite';
import createEvent from '@/scripts/utils/create-event';
import _debounce from 'lodash/debounce';


window.addEventListener('resize', _debounce(() => {
  window.dispatchEvent(createEvent('resizeEnd'));
}, 100));

let oldWidth;
let elements;

function resizeElements() {
  oldWidth = window.innerWidth;
  TweenLite.set(elements, {
    height: Math.max(window.innerHeight, 650),
  });
}

export default function resizeCover() {
  elements = document.querySelectorAll('.cover_full');
  resizeElements();
  window.addEventListener('resizeEnd', () => {
    if (oldWidth !== window.innerWidth) {
      resizeElements();
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/elements/cover.js